import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import Ticket from '../../../records/Ticket';
import Fare from '../../../records/Fare';
import OrderFare from '../../../records/order/Fare';
import OrderTicket from '../../../records/order/Ticket';

import PassengerInfo from "../../fares/details/PassengerInfo";
import Price from '../../general/Price';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import RailcardBadge from './RailcardBadge';
import NRETicketLink from '../NRETicketLink';
import FeatureFlag from "../../general/FeatureFlag";

function TicketDetails ({ fare, ticket, isFlexi, isCarnet }) {
    const { adults, children, railcard, price, ticketTypeOverride } = ticket;
    let ticketType = 'ticket';

    if (isCarnet) {
        ticketType = 'carnet';
    }

    return (
        <li className="clearfix text-weight--normal">
            <Row className="passenger-row">
                <Col xs={ 8 } sm={ 6 } className="pull-left">
                    <div className="padding-bottom--xs">
                        <FormattedHTMLMessage message={ `booking.fares.details.${ ticketType }` }
                                              adults={ isFlexi ? 1 : adults }
                                              children={ children }
                                              individualPrice={ <Price price={ price / (adults + children) } /> }
                                              passes={ fare.getNumberOfPasses() }
                                              ticketTypeOverride={ ticketTypeOverride ? ticketTypeOverride.shortenName() : 0 }
                                              className="text-sm"/>
                        <FeatureFlag name="enableSmartcardAssociations">
                            <PassengerInfo className="passenger-row__linked-smartcard" ticket={ticket} />
                        </FeatureFlag>
                        <FeatureFlag name="showNRETicketLink">
                            {' '}
                            <NRETicketLink
                                ticket={ ticket }
                                fare={ fare }
                            />
                        </FeatureFlag>
                    </div>
                    { railcard && <RailcardBadge railcard={ railcard } /> }
                </Col>
                <Col xs={ 4 } sm={ 6 } className="text-right">
                    <Price price={ price } className="passenger-row__price text-sm"/>
                </Col>
            </Row>
        </li>
    );
}

TicketDetails.propTypes = {
    fare: PropTypes.oneOfType([
        PropTypes.instanceOf(Fare),
        PropTypes.instanceOf(OrderFare)
    ]),
    ticket: PropTypes.oneOfType([
        PropTypes.instanceOf(Ticket),
        PropTypes.instanceOf(OrderTicket)
    ]),
    isCarnet: PropTypes.bool,
    isFlexi: PropTypes.bool,
};

export default TicketDetails;
